import React from "react";
import { Button, makeStyles, mergeClasses } from "@fluentui/react-components";
import { themeTokens } from "../utils/Theming";
import { ArrowLeft16Regular, ArrowRight16Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    padding: "10px 20px",
    backgroundColor: themeTokens.colorNeutralBackground3,
    zIndex: 1,
  },
  button: {
    padding: "5px 0",
    display: "flex",
    "&:hover": {
      background: "transparent",
    },
  },
  backButton: {
    justifyContent: "flex-start",
  },
  nextButton: {
    justifyContent: "flex-end",
  },
});

const PageHeader = ({ onBack = null, onNext = null, backLabel = "Back", nextLabel = "Next" }) => {
  const styles = useStyles();

  const getJustifyContent = () => {
    if (onBack && onNext) return "space-between";
    if (onBack) return "flex-start";
    if (onNext) return "flex-end";
    return "center";
  };

  return (
    <header className={styles.header} style={{ justifyContent: getJustifyContent() }}>
      {onBack && (
        <Button
          className={mergeClasses(styles.button, styles.backButton)}
          appearance="subtle"
          icon={<ArrowLeft16Regular />}
          onClick={onBack}
        >
          {backLabel}
        </Button>
      )}
      {onNext && (
        <Button
          className={mergeClasses(styles.button, styles.nextButton)}
          appearance="subtle"
          icon={<ArrowRight16Regular />}
          iconPosition="after"
          onClick={onNext}
        >
          {nextLabel}
        </Button>
      )}
    </header>
  );
};

export default PageHeader;
